import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import { ModalData } from '../model-data';
import * as moment from 'moment';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { FormGroup, FormBuilder,FormControl, Validators } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import { NgbDateStruct, NgbDate, NgbCalendar, NgbDateParserFormatter, NgbDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../services/common.service';
import { PopupComponent } from './popup/popup.component';
@Component({
  selector: 'app-dialogs',
  templateUrl: './dialogs.component.html',
  styleUrls: ['./dialogs.component.scss']
})
export class DialogsComponent implements OnInit {
  public hotelsData:any={};
  public opens:string = 'center';
  minDate: moment.Moment = moment();
  end: moment.Moment = moment().add(2, 'days');
  public searchForm: FormGroup;
  public searchFormData:any = {};
  public dateError:boolean = false;
  public showHotels:boolean = true;
  public dateErrorTxt:string = '';
  public hotel_code:string = 'manhattantowerfl';
  public notAvailableRooms:any={};
  public ctd_dates:any= {};
  public cta_dates:any={};
  public minStay:any={};
  public selectedDates = {start: this.minDate, end: this.end };  
  public minDateFormat: any;
  public hoveredDate: NgbDate;
  public fromDate: NgbDate;
  public toDate: NgbDate;
  public navigation: string = "arrows";
  public searchDateDisplayValue: string;
  private hotelsDataSubscription;
  Destinations = [
    {value: 'a-0', viewValue: 'Destinations'},
    {value: 'b-1', viewValue: 'Destinations1'},
    {value: 'c-2', viewValue: 'Destinations2'}
  ];
  Adults = [
    {viewValue: 'Adults-1', value: 1},
    {viewValue: 'Adults-2', value: 2},
    {viewValue: 'Adults-3', value: 3},
    {viewValue: 'Adults-4', value: 4},
    {viewValue: 'Adults-5', value: 5},
    {viewValue: 'Adults-6', value: 6}
  ];
  kids = [
    {viewValue: 'Kids-0', value: 0},
    {viewValue: 'Kids-1', value: 1},
    {viewValue: 'Kids-2', value: 2},
    {viewValue: 'Kids-3', value: 3},
    {viewValue: 'Kids-4', value: 4}
   
  ];
  Rates = [  
    {value: 'Government', viewValue: 'Government'},
    {value: 'Vetern', viewValue: 'Vetern'},
    {value: 'AAA', viewValue: 'AAA'},
    {value: 'Senior', viewValue: 'Senior'},
    {value: 'Special Offer', viewValue: 'Special Offer'},
    {value: 'Group', viewValue: 'Group'}
  ];
  checkdates(){
    if(this.searchFormData.selectedDates == undefined){
      this.searchFormData.selectedDates ='';
    }
  }
 
  searchRooms(){
    this.searchFormData = this.searchForm.value;
    var hotel_code = this.searchFormData.destination;
    var room_stay_from = moment(this.searchFormData.selectedDates.start).format('YYYY-MM-DD');
    var room_stay_to = moment(this.searchFormData.selectedDates.end).format('YYYY-MM-DD');
    var adults = this.searchFormData.adults;
    var child = this.searchFormData.kids;
    if(this.searchForm.valid){
        this.router.navigate(['/search-results/'+hotel_code+'/'+room_stay_from+'/'+room_stay_to+'/'+adults+"/"+child]);
        this.dialogRef.close();
    }
  }
  constructor(
    public dialogRef: MatDialogRef<DialogsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalData ,
    private router: Router,private fb: FormBuilder,
    private calendar: NgbCalendar, 
    public formatter: NgbDateParserFormatter,
    private config: NgbDatepickerConfig,
    private commonService :CommonService,
    public dialog: MatDialog)
  {
    this.hotelsDataSubscription = this.commonService.HotelsData.subscribe((hotelsData:any) => {
      if(hotelsData != '' && hotelsData[0] != undefined && hotelsData.length >0){
        this.hotelsData = hotelsData;
      }
    });
    if(this.data.hotelname ==''){
      this.showHotels =true;
      this.hotel_code ='manhattantowerfl';
    } else{
      this.showHotels = false;
      this.hotel_code =this.data.hotelname;
    }
    const current = new Date();
    config.minDate = { year: current.getFullYear(), month: 
    current.getMonth() + 1, day: current.getDate() };
    config.outsideDays = 'hidden';
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 2);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.searchForm = this.fb.group({
      destination: [this.hotel_code, [Validators.required]],
      selectedDates: [this.selectedDates, [Validators.required]],
      adults: [2, [Validators.required]],
      kids: [0, [Validators.required]],
      rates: ['']
    });
    let fromDateRes = moment(this.minDate).format('YYYY-MM-DD');
    let toDateRes = moment(this.end).format('YYYY-MM-DD');
    let fromDateResFormat = moment(this.minDate).format('YYYY/MM/DD');
    let toDateResFormat = moment(this.end).format('YYYY/MM/DD');
    this.searchDateDisplayValue = fromDateResFormat + ' - ' + toDateResFormat;
    this.searchForm.value.selectedDates = {start: fromDateRes, end: toDateRes };
  }

 onDateSelection(date: NgbDate) {
    var newdate =  moment(date.day+'/'+date.month+'/'+date.year).format('DD/MM/YYYY');
    if (!this.fromDate && !this.toDate) {
      if(Object.keys(this.cta_dates).length >0){
        if(this.cta_dates.indexOf(newdate)){
          this.openDialog(
            {
              'message':'Rooms are unavailable on your selected dates. Please choose different stay period.',
              'title':'Rooms unavialable',
              'confirm': false
            }
          );
        } else {
          this.fromDate = date;
        }
      } else {
        this.fromDate = date;
      }
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      if(Object.keys(this.cta_dates).length >0){
        if(this.ctd_dates.indexOf(newdate)){
          this.openDialog(
            {
              'message':'Rooms are unavailable on your selected dates. Please choose different stay period.',
              'title':'Rooms unavialable',
              'confirm': false
            }
          );
        } else {
          this.toDate = date;
        }
      } else {
        this.toDate = date;
      }
    } else {
      this.toDate = null;
      if(Object.keys(this.cta_dates).length >0){
        if(this.cta_dates.indexOf(newdate)){
          this.openDialog(
            {
              'message':'Rooms are unavailable on your selected dates. Please choose different stay period.',
              'title':'Rooms unavialable',
              'confirm': false
            }
          );
        } else {
          this.fromDate = date;
        }
      } else {
        this.fromDate = date;
      }
    }
    
    if(this.fromDate !== null && this.toDate !== null){
      if(this.notAvailableRooms.length>0){
        let fromDateRes = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
        fromDateRes = moment(fromDateRes).format('YYYY-MM-DD');
        let toDateRes = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
        toDateRes = moment(toDateRes).format('YYYY-MM-DD');
        let flag = true;
        this.notAvailableRooms.forEach((val,key)=>{
          if(flag){
            let  notAvailabeleDate = val.split('/');
            let checkDate =  moment(notAvailabeleDate[2]+'-'+notAvailabeleDate[0]+'-'+notAvailabeleDate[1]).format('YYYY-MM-DD');

            if(moment(checkDate).isBetween(fromDateRes, toDateRes)){
              this.fromDate = null;
              this.toDate = null;
              flag = false;
              this.openDialog(
            {
              'message':'Rooms are unavailable on your selected dates. Please choose different stay period.',
              'title':'Rooms unavialable',
              'confirm': false
            }
          );
            }             
          }
        });
      }  

       let minStayDates = Object.keys(this.minStay);
      if(minStayDates.length>0){
        let fromDateRes = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
        let minStayDate =  this.fromDate.month + '/' + this.fromDate.day + '/' +this.fromDate.year ;
        fromDateRes = moment(fromDateRes).format('YYYY-MM-DD');
        let toDateRes = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
        toDateRes = moment(toDateRes).format('YYYY-MM-DD');
        let diff = moment(toDateRes).diff(moment(fromDateRes),'days');
        let flag =false;
        let newfromDate = '';
        minStayDates.forEach((id,nkey)=>{
          if(!flag){
            newfromDate = id;
            var datenumber = id.split('/');
            datenumber.forEach((val,key)=>{
              if(parseInt(val)< 10){
                datenumber[key] = (parseInt(val)%10).toString();
              }
            });
            id = datenumber.join('/');
            if(id == minStayDate){
              flag =true;
            }
          }
        });
        if(flag){
          if( diff < parseInt(this.minStay[newfromDate])){
            this.fromDate = null;
            this.toDate = null ;
            this.openDialog(
                {
                  'message':'You stay must include '+this.minStay[newfromDate]+' nights.',
                  'title':'Minimum length Required',
                  'confirm':false
                }
              );
          }
        }
        
      } 
    }

    if(this.fromDate && this.fromDate !== null) {
      let fromDateRes = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
      this.searchForm.value.selectedDates.start = fromDateRes;
    }
    if(this.toDate && this.toDate !== null) {
      let toDateRes = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
      this.searchForm.value.selectedDates.end = toDateRes;
    }

    if(this.toDate && this.toDate !== null) {
       let fromDateResFormat = this.fromDate.year + '/' + this.fromDate.month + '/' + this.fromDate.day;
      let toDateResFormat = this.toDate.year + '/' + this.toDate.month + '/' + this.toDate.day;
      this.searchDateDisplayValue = fromDateResFormat + ' - ' + toDateResFormat;
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
  }    

  isDisabled = (date)=> {
    // var newdate =  moment(date.day+'/'+date.month+'/'+date.year).format('DD/MM/YYYY');
    // if(this.notAvailableRooms.length>0){
    //   if(this.notAvailableRooms.indexOf(newdate) !== -1 && this.fromDate !== null && this.toDate !== null){
    //     let checkDate =  moment(date.year+'-'+date.month+'-'+date.day).format('YYYY-MM-DD');
    //     if(moment(checkDate).isBetween(this.fromDate, this.toDate)){
    //       this.fromDate = null;
    //       this.toDate = null;
    //     }
    //     let calendar =document.querySelector('.simple-datepicker');
    //     let dayCell = calendar.querySelectorAll('.ngb-dp-day');
    //     dayCell.forEach((element,key)=>{
    //       if(element.querySelector('.disabled') !== null){
    //         element.classList.add("disabled");
    //       }
    //     });
    //     return true;
    //   } else if(this.notAvailableRooms.indexOf(newdate) !== -1 && (this.fromDate === null || this.toDate === null)){
    //     let calendar =document.querySelector('.simple-datepicker');
    //     let dayCell = calendar.querySelectorAll('.ngb-dp-day');
    //     dayCell.forEach((element,key)=>{
    //       if(element.querySelector('.disabled') !== null){
    //         element.classList.add("disabled");
    //       }
    //     });
    //     return true;
    //   }else {
    //     return false;
    //   }
    // } else {
    //     return false;
    // }
  }


  //Function to get Stopsell, CTA and CTD.
  getStopSellCtaCtd(event){
    let calendarView = document.querySelector('.dropdown');
    if (calendarView instanceof HTMLElement) { 
      let days = calendarView.getElementsByClassName('ngb-dp-day');
      for(let i = 0; i < days.length; i++) {
        // days[i].setAttribute('style','height:'+offsetHeight+' !important');
        days[i].classList.remove('disabled');  
        days[i].classList.remove('mls_days');
      }
    }
    var currentDate = event.month+"/"+'01'+"/"+event.year;
      var lastDate = moment(currentDate, "MM/DD/YYYY").add(1, 'M').endOf("month").format('YYYY-MM-DD');
      currentDate = moment(currentDate).format('YYYY-MM-DD');
      if(this.hotel_code != '' && this.hotel_code != undefined){
        var selectedHotel = this.hotel_code;
        this.commonService.getStopSellCtaCtd({'from':currentDate,'to': lastDate,'selectedHotel':selectedHotel}).then((data:any) => {
          let a =data.data.not_available_rooms;
          let cta_dates = data.data.cta_dates;
          let ctd_dates = data.data.ctd_dates;
          let ctd_unique = ctd_dates.filter((item, i, ar) => ar.indexOf(item) === i);
          let cta_unique = cta_dates.filter((item, i, ar) => ar.indexOf(item) === i);
          let unique = a.filter((item, i, ar) => ar.indexOf(item) === i);
          this.cta_dates = cta_unique;
          this.ctd_dates = ctd_unique;
          this.notAvailableRooms = unique;
          if(this.notAvailableRooms.length>0){
            this.notAvailableRooms.forEach((id,nkey)=>{
              var datenumber = id.split('/');
              datenumber.forEach((val,key)=>{
                if(parseInt(val)< 10){
                  datenumber[key] = parseInt(val)%10;
                }
              });
                id = datenumber.join('/');
                var element = document.getElementById('dialog_'+id);
                if(element !== null){
                  let parent = element.parentNode;
                  if(parent instanceof HTMLElement) {
                    parent.classList.add("disabled");
                  }
                }
            });
          }

          this.minStay = data.data.min_stay;
           let minStayfromDate =  this.fromDate.month + '/' + this.fromDate.day + '/' +this.fromDate.year ;
          let minStaytoDate =  this.toDate.month + '/' + this.toDate.day + '/' +this.toDate.year ;
          if(Object.keys(this.minStay).length>0){
            Object.keys(this.minStay).forEach((key)=>{
             if(parseInt(this.minStay[key])>1){
               var datenumber = key.split('/');
                datenumber.forEach((val,i)=>{
                  if(parseInt(val)< 10){
                    datenumber[i] = (parseInt(val)%10).toString();
                  }
                });
                let id = datenumber.join('/');
                if(minStayfromDate === id || minStaytoDate === id){
                    this.fromDate = null;
                    this.toDate = null
                  }
                var element = document.getElementById('dialog_'+id);
                let parent = element.parentNode;
                if(parent instanceof HTMLElement) {
                  parent.classList.add("mls_days");
                }
             }
            });
          }
          if(this.fromDate !== null && this.fromDate !== undefined){
            var room_stay_from = moment(this.fromDate.day+'/'+this.fromDate.month+'/'+this.fromDate.year).format('DD/MM/YYYY');
          }
          if(this.toDate !== null && this.toDate !== undefined){
            var room_stay_to = moment(this.toDate.day+'/'+this.toDate.month+'/'+this.toDate.year).format('DD/MM/YYYY');
          }
          if(this.notAvailableRooms.indexOf(room_stay_from) !== -1|| this.notAvailableRooms.indexOf(room_stay_to) !== -1){
            this.fromDate = null;
            this.toDate = null;
          }
        });
      }  
  }

  /**************************
  *To Show Error  dialog box*
  **************************/
  openDialog(data): void {
    const dialogRef = this.dialog.open(PopupComponent, {
      width: '600px',
      data: data,
       panelClass: 'mlspopblock'
    });

    dialogRef.afterClosed().subscribe(res => {
      
    });
  }
}
